// export const FETCH_UNASSIGNED_GROUPS = "[ADMIN] FETCH_UNASSIGNED_GROUPS";
// export const FETCH_UNASSIGNED_GROUPS_START = "[ADMIN] FETCH_UNASSIGNED_GROUPS_START";
// export const FETCH_UNASSIGNED_GROUPS_SUCCESS = "[ADMIN] FETCH_UNASSIGNED_GROUPS_SUCCESS";
// export const FETCH_UNASSIGNED_GROUPS_ERROR = "[ADMIN] FETCH_UNASSIGNED_GROUPS_ERROR";

// export const RESET_UNASSIGNED_GROUPS = "[ADMIN] RESET_UNASSIGNED_GROUPS";

export const FETCH_ALL_GROUPS = "[ADMIN] FETCH_ALL_GROUPS";
export const FETCH_ALL_GROUPS_SUCCESS = "[ADMIN] FETCH_ALL_GROUPS_SUCCESS";
export const FETCH_ALL_GROUPS_ERROR = "[ADMIN] FETCH_ALL_GROUPS_ERROR";
export const FETCH_ALL_GROUPS_START = "[ADMIN] FETCH_ALL_GROUPS_START";
export const SET_ALL_GROUPS_PAGINATION = "[ADMIN] SET_ALL_GROUPS_PAGINATION";
export const RESET_GROUPS = "[ADMIN] RESET_GROUPS";

export const FETCH_ALL_GROUP_MEMBERS = "[ADMIN] FETCH_ALL_GROUP_MEMBERS";
export const FETCH_ALL_GROUP_MEMBERS_SUCCESS = "[ADMIN] FETCH_ALL_GROUP_MEMBERS_SUCCESS";
export const FETCH_ALL_GROUP_MEMBERS_ERROR = "[ADMIN] FETCH_ALL_GROUP_MEMBERS_ERROR";
export const FETCH_ALL_GROUP_MEMBERS_START = "[ADMIN] FETCH_ALL_GROUP_MEMBERS_START";

export const ADD_UPDATE_GROUP = "[ADMIN] ADD_UPDATE_GROUP";
export const ADD_UPDATE_GROUP_START = "[ADMIN] ADD_UPDATE_GROUP_START";
export const ADD_UPDATE_GROUP_SUCCESS = "[ADMIN] ADD_UPDATE_GROUP_SUCCESS";
export const ADD_UPDATE_GROUP_ERROR = "[ADMIN] ADD_UPDATE_GROUP_ERROR";

export const FETCH_UNASSIGNED_GROUP_MEMBERS = "[ADMIN] FETCH_UNASSIGNED_GROUP_MEMBERS";
export const FETCH_UNASSIGNED_GROUP_MEMBERS_START = "[ADMIN] FETCH_UNASSIGNED_GROUP_MEMBERS_START";
export const FETCH_UNASSIGNED_GROUP_MEMBERS_SUCCESS = "[ADMIN] FETCH_UNASSIGNED_GROUP_MEMBERS_SUCCESS";
export const FETCH_UNASSIGNED_GROUP_MEMBERS_ERROR = "[ADMIN] FETCH_UNASSIGNED_GROUP_MEMBERS_ERROR";

export const ADD_GROUP_MEMBER = "[ADMIN] ADD_GROUP_MEMBER";
export const ADD_GROUP_MEMBER_START = "[ADMIN] ADD_GROUP_MEMBER_START";
export const ADD_GROUP_MEMBER_SUCCESS = "[ADMIN] ADD_GROUP_MEMBER_SUCCESS";
export const ADD_GROUP_MEMBER_ERROR = "[ADMIN] ADD_GROUP_MEMBER_ERROR";

export const REMOVE_GROUP_MEMBER = "[ADMIN] REMOVE_GROUP_MEMBER";
export const REMOVE_GROUP_MEMBER_START = "[ADMIN] REMOVE_GROUP_MEMBER_START";
export const REMOVE_GROUP_MEMBER_SUCCESS = "[ADMIN] REMOVE_GROUP_MEMBER_SUCCESS";
export const REMOVE_GROUP_MEMBER_ERROR = "[ADMIN] REMOVE_GROUP_MEMBER_ERROR";

export const SHOW_UNASSIGNED_GROUP_MEMEBERS_MODAL = "[ADMIN] SHOW_UNASSIGNED_GROUP_MEMEBERS_MODAL";
export const HIDE_UNASSIGNED_GROUP_MEMEBERS_MODAL = "[ADMIN] HIDE_UNASSIGNED_GROUP_MEMEBERS_MODAL";
// export const fetchUnassignedGroups = (userId) => {
//     return {
//         type: FETCH_UNASSIGNED_GROUPS,
//         userId
//     };
// };

// export const resetUnassignedGroups = () => {
//     return {
//         type: RESET_UNASSIGNED_GROUPS,
//     };
// };

export const fetchAllGroups = (name) => {
    return {
        type: FETCH_ALL_GROUPS,
        payload: name
    };
};

export const resetGroups = () => {
    return {
        type: RESET_GROUPS,
    };
};

export const fetchGroupMembers = (groupId) => {
    return {
        type: FETCH_ALL_GROUP_MEMBERS,
        payload: groupId
    }
}

export const addUpdateGroup = (group) => {
    return {
        type: ADD_UPDATE_GROUP,
        payload: group
    }
}

export const fetchUnassignedGroupMembers = (groupId) => {
    return {
        type: FETCH_UNASSIGNED_GROUP_MEMBERS,
        payload: groupId
    }
}

export const addGroupMember = (data) => {
    return {
        type: ADD_GROUP_MEMBER,
        payload: data
    }
}

export const removeGroupMember = (data) => {
    return {
        type: REMOVE_GROUP_MEMBER,
        payload: data
    }
}

export const closeUnassignedGroupMembersModal = () => {
    return {
        type: HIDE_UNASSIGNED_GROUP_MEMEBERS_MODAL

    }
}

export const showUnassignedGroupMembersModal = () => {
    return {
        type: SHOW_UNASSIGNED_GROUP_MEMEBERS_MODAL
    }
}